import script from "./HomeServiceComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeServiceComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeServiceComponent.vue?vue&type=style&index=0&id=12024d4c&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12024d4c"]])

export default __exports__